<template>
  <div class="disease-desc">
    <div class="header">
      <van-icon name="cross" class="icon-close" @click="handleClose" />
      <h2 class="title">填写疾病描述</h2>
      <span class="btn-cross" @click="handleCross">跳过</span>
    </div>
    <div class="text-area">
      <h3 class="sub-title">病情描述</h3>
      <van-field 
        type="textarea" 
        placeholder="为了更好的获得医生的帮助，请尽可能详细描述病情"
        show-word-limit
        :maxlength="200"
        v-model="textDesc"
        />
    </div>
    <div class="img-area">
      <h3 class="sub-title">请上传能反映病情的相关资料</h3>
      <span class="hint">最多支持上传 4 张图片</span>
      <UploadImage :limit="4" @handleImageChange="handleImageChange" />
    </div>
    <div class="bottom">
      <van-button type="primary" block size="middle" @click="handleConfirm">确认</van-button>
    </div>
  </div>
</template>
<script>
import UploadImage from './UploadImage';

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      textDesc: '',
      imageList: [],
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleCross() {
      this.$emit('cross');
    },
    handleConfirm() {
      const { textDesc, imageList } = this;
      if (!textDesc) {
        this.$toast('请输入疾病描述');
        return;
      }
      this.$emit('confirm', JSON.stringify({
        textDesc,
        imageList
      }));
    },
    handleImageChange(list) {
      this.imageList = list || [];
    }
  }
}
</script>
<style lang="less" type="text/less" scoped>
.disease-desc {
  background: #F5F5F5;
  .header {
    height: 48px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    background: #fff;
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 18px;
    }
    .icon-close {
      font-size: 20px;
      color: #262626;
      margin-top: 6px;
    }
    .btn-cross {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 16px;
    }
  }
  .text-area {
    padding: 16px;
    background: #fff;
    margin-bottom: 10px;
    .sub-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 16px;
    }
    .van-field {
      background: #F7F8FA;
      margin-top: 16px;
      /deep/ .van-field__type-textarea {
        height: 84px;
      }
    }
  }
  .img-area {
    padding: 16px 16px 8px;
    background: #fff;
    margin-bottom: 10px;
    .sub-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 16px;
    }
    .hint {
      display: block;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8C8C8C;
      line-height: 14px;
      margin: 8px 0 16px;
    }
  }
  .bottom {
    padding: 8px 16px;
    background: #fff;
  }
}

</style>